import { getType } from "typesafe-actions";
import * as loadingBars from "./actions";
export var initialState = false;
export var loadingBarsReducer = function loadingBarsReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(loadingBars.set):
      return action.payload;

    default:
      return state;
  }
};